import {
  DELETE_USER,
  DOWNLOAD_INVOICES,
  GET_ACTIVE_ROOMS,
  GET_CLOSED_ROOMS,
  GET_SEATS,
  GET_SUBSCRIPTION,
  GET_SUBSCRIPTION_BRANDING,
  GET_SUBSCRIPTION_INVOICES,
  GET_SUBSCRIPTION_USERS,
  PATCH_SUB_ADMIN,
  PATCH_SUB_ADMIN_BILLING,
  PATCH_SUB_ADMIN_USER,
  POST_NEW_SUBSCRIBER,
  INCREASE_DATAROOM_PLAN,
  RESTORE_ROOM,
  POST_SUBSCRIPTION_TEAM,
  POST_ELECTRONIC_VAULT_QUOTE_REQUEST,
  PATCH_SUBSCRIPTION_TEAM,
  GET_SUBSCRIPTION_TEAMS,
  DELETE_SUBSCRIPTION_TEAM,
  GET_SUBSCRIPTION_CONSUMPTION_PACKS,
  GET_SUBSCRIPTION_DATAROOM_STORAGE,
  SHARE_SUBSCRIPTION_CONSUMPTION_PACK,
  SHARE_SUBSCRIPTION_DATAROOM_PLAN,
  GET_SIGNATURES_CONSUMPTION,
} from './action_types'
import {
  SET_SUBSCRIPTION,
  SET_SUBSCRIPTION_PENDING,
  SET_SUBSCRIPTION_BRANDING,
  SET_SUBSCRIPTION_BRANDING_PENDING,
  SET_SUBSCRIPTION_ERROR,
  SET_SUBSCRIPTION_USERS,
  SET_SUBSCRIPTION_USERS_PENDING,
  SET_SUBSCRIPTION_USERS_ERROR,
  SET_PATCH_SUB_ADMIN_PENDING,
  REMOVE_PATCH_SUB_ADMIN_PENDING,
  SET_PATCH_SUB_ADMIN_ERROR,
  SET_USER_SUB_ADMIN,
  SET_PATCH_SUB_ADMIN_BILLING_PENDING,
  REMOVE_PATCH_SUB_ADMIN_BILLING_PENDING,
  SET_PATCH_SUB_ADMIN_BILLING_ERROR,
  SET_USER_SUB_ADMIN_BILLING,
  SET_PATCH_SUB_ADMIN_USER_PENDING,
  REMOVE_PATCH_SUB_ADMIN_USER_PENDING,
  SET_PATCH_SUB_ADMIN_USER_ERROR,
  SET_USER_SUB_ADMIN_USER,
  SET_DELETE_USER_PENDING,
  SET_DELETE_USER_ERROR,
  SET_POST_NEW_SUBSCRIBER_PENDING,
  SET_POST_NEW_SUBSCRIBER_ERROR,
  SET_ACTIVE_ROOMS,
  SET_ACTIVE_ROOMS_PENDING,
  SET_ACTIVE_ROOMS_ERROR,
  SET_CLOSED_ROOMS,
  SET_CLOSED_ROOMS_PENDING,
  SET_CLOSED_ROOMS_ERROR,
  SET_POST_SUBSCRIPTION_TEAM_PENDING,
  SET_PATCH_SUBSCRIPTION_TEAM_PENDING,
  SET_SUBSCRIPTION_TEAMS_PENDING,
  SET_SUBSCRIPTION_TEAMS,
  SET_SUBSCRIPTION_TEAMS_ERROR,
  SET_SUBSCRIPTION_CONSUMPTION_PACKS_PENDING,
  SET_SUBSCRIPTION_CONSUMPTION_PACKS,
  SET_SUBSCRIPTION_CONSUMPTION_PACKS_ERROR,
  SET_SUBSCRIPTION_DATAROOM_STORAGE_PENDING,
  SET_SUBSCRIPTION_DATAROOM_STORAGE,
  SET_SUBSCRIPTION_DATAROOM_STORAGE_ERROR,
  SET_SUBSCRIPTION_INVOICES,
  SET_SUBSCRIPTION_INVOICES_PENDING,
  SET_SUBSCRIPTION_INVOICES_ERROR,
  SET_DOWNLOAD_INVOICES_PENDING,
  SET_DOWNLOAD_INVOICES_ERROR,
  SET_RESTORE_ROOM_PENDING,
  SET_RESTORE_ROOM_ERROR,
  SET_SEATS,
  SET_SEATS_PENDING,
  SET_SEATS_ERROR,
  SET_DELETE_SUBSCRIPTION_TEAM_PENDING,
  SET_INCREASE_DATAROOM_PLAN_PENDING,
  SET_SHARE_SUBSCRIPTION_CONSUMPTION_PACK_PENDING,
  SET_SHARE_SUBSCRIPTION_DATAROOM_PLAN_PENDING,
  SET_SIGNATURES_CONSUMPTION_PENDING,
  SET_SIGNATURES_CONSUMPTION,
  SET_SIGNATURES_CONSUMPTION_ERROR,
} from './mutation_types'
import service from '../../../services/subscription.service'

export const actions = {
  async [GET_SEATS] ({ commit }) {
    commit(SET_SEATS_PENDING, true)
    commit(SET_SEATS_ERROR, null)
    try {
      const { data } = await service.getSeats()
      commit(SET_SEATS, data.seats)
    } catch (error) {
      commit(SET_SEATS_ERROR, error)
      throw error
    } finally {
      commit(SET_SEATS_PENDING, false)
    }
  },
  async [RESTORE_ROOM] ({ commit }, params) {
    commit(SET_RESTORE_ROOM_PENDING, true)
    try {
      await service.restoreRoom(params.roomId, params.data)
    } catch (error) {
      commit(SET_RESTORE_ROOM_ERROR, error)
      throw error
    } finally {
      commit(SET_RESTORE_ROOM_PENDING, false)
    }
  },
  async [POST_NEW_SUBSCRIBER] ({ commit }, data) {
    commit(SET_POST_NEW_SUBSCRIBER_PENDING, true)
    try {
      await service.postNewSubscriber(data)
    } catch (error) {
      commit(SET_POST_NEW_SUBSCRIBER_ERROR, error)
      throw error
    } finally {
      commit(SET_POST_NEW_SUBSCRIBER_PENDING, false)
    }
  },
  async [DELETE_USER] ({ commit }, userId) {
    commit(SET_DELETE_USER_PENDING, true)
    try {
      await service.deleteUser(userId)
    } catch (error) {
      commit(SET_DELETE_USER_ERROR, error)
      throw error
    } finally {
      commit(SET_DELETE_USER_PENDING, false)
    }
  },
  async [PATCH_SUB_ADMIN_USER] ({ commit, state }, { userId, data }) {
    commit(SET_PATCH_SUB_ADMIN_USER_PENDING, userId)
    try {
      const response = await service.patchSubAdminUser(userId, data)
      if (response.status === 200) {
        commit(SET_USER_SUB_ADMIN_USER, userId)
      }
    } catch (error) {
      commit(SET_PATCH_SUB_ADMIN_USER_ERROR, error)
      throw error
    } finally {
      commit(REMOVE_PATCH_SUB_ADMIN_USER_PENDING,
        state.patchSubAdminUserPendingIds.indexOf(userId))
    }
  },
  async [PATCH_SUB_ADMIN_BILLING] ({ commit, state }, { userId, data }) {
    commit(SET_PATCH_SUB_ADMIN_BILLING_PENDING, userId)
    try {
      const response = await service.patchSubAdminBilling(userId, data)
      if (response.status === 200) {
        commit(SET_USER_SUB_ADMIN_BILLING, userId)
      }
    } catch (error) {
      commit(SET_PATCH_SUB_ADMIN_BILLING_ERROR, error)
      throw error
    } finally {
      commit(REMOVE_PATCH_SUB_ADMIN_BILLING_PENDING,
        state.patchSubAdminBillingPendingIds.indexOf(userId))
    }
  },
  async [PATCH_SUB_ADMIN] ({ commit, state }, { userId, data }) {
    commit(SET_PATCH_SUB_ADMIN_PENDING, userId)
    try {
      const response = await service.patchSubAdmin(userId, data)
      if (response.status === 200) {
        commit(SET_USER_SUB_ADMIN, userId)
      }
    } catch (error) {
      commit(SET_PATCH_SUB_ADMIN_ERROR, error)
      throw error
    } finally {
      commit(REMOVE_PATCH_SUB_ADMIN_PENDING,
        state.patchSubAdminPendingIds.indexOf(userId))
    }
  },
  async [GET_SUBSCRIPTION_USERS] ({ commit }) {
    commit(SET_SUBSCRIPTION_USERS_PENDING, true)
    try {
      const response = await service.getSubscriptionUsers()
      commit(SET_SUBSCRIPTION_USERS, response.data)
    } catch (error) {
      commit(SET_SUBSCRIPTION_USERS_ERROR, error)
      throw error
    } finally {
      commit(SET_SUBSCRIPTION_USERS_PENDING, false)
    }
  },
  async [GET_ACTIVE_ROOMS] ({ commit }) {
    commit(SET_ACTIVE_ROOMS_PENDING, true)
    try {
      const response = await service.getActiveRooms()
      commit(SET_ACTIVE_ROOMS, response.data)
    } catch (error) {
      commit(SET_ACTIVE_ROOMS_ERROR, error)
      throw error
    } finally {
      commit(SET_ACTIVE_ROOMS_PENDING, false)
    }
  },
  async [GET_CLOSED_ROOMS] ({ commit }) {
    commit(SET_CLOSED_ROOMS_PENDING, true)
    try {
      const response = await service.getClosedRooms()
      commit(SET_CLOSED_ROOMS, response.data)
    } catch (error) {
      commit(SET_CLOSED_ROOMS_ERROR, error)
      throw error
    } finally {
      commit(SET_CLOSED_ROOMS_PENDING, false)
    }
  },
  async [POST_SUBSCRIPTION_TEAM] ({ commit }, data) {
    commit(SET_POST_SUBSCRIPTION_TEAM_PENDING, true)
    try {
      await service.postSubscriptionTeam(data)
    } catch (error) {
      console.error(error)
      throw error
    } finally {
      commit(SET_POST_SUBSCRIPTION_TEAM_PENDING, false)
    }
  },
  // No pending state: the dialog tracks its own loading flag locally (used across all three
  // quote-request topics, not just this one), so a Vuex-level flag here would have no consumer.
  async [POST_ELECTRONIC_VAULT_QUOTE_REQUEST] (_, data) {
    try {
      await service.postElectronicVaultQuoteRequest(data)
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  async [PATCH_SUBSCRIPTION_TEAM] ({ commit }, { teamId, data }) {
    commit(SET_PATCH_SUBSCRIPTION_TEAM_PENDING, true)
    try {
      await service.patchSubscriptionTeam(teamId, data)
    } catch (error) {
      console.error(error)
      throw error
    } finally {
      commit(SET_PATCH_SUBSCRIPTION_TEAM_PENDING, false)
    }
  },
  async [DELETE_SUBSCRIPTION_TEAM] ({ commit }, teamId) {
    commit(SET_DELETE_SUBSCRIPTION_TEAM_PENDING, true)
    try {
      await service.deleteSubscriptionTeam(teamId)
    } catch (error) {
      console.error(error)
      throw error
    } finally {
      commit(SET_DELETE_SUBSCRIPTION_TEAM_PENDING, false)
    }
  },
  async [GET_SUBSCRIPTION_TEAMS] ({ commit }) {
    commit(SET_SUBSCRIPTION_TEAMS_PENDING, true)
    commit(SET_SUBSCRIPTION_TEAMS_ERROR, null)
    try {
      const response = await service.getSubscriptionTeams()
      commit(SET_SUBSCRIPTION_TEAMS, response.data.data)
    } catch (error) {
      console.error(error)
      commit(SET_SUBSCRIPTION_TEAMS_ERROR, error)
      throw error
    } finally {
      commit(SET_SUBSCRIPTION_TEAMS_PENDING, false)
    }
  },
  async [GET_SUBSCRIPTION_CONSUMPTION_PACKS] ({ commit }) {
    commit(SET_SUBSCRIPTION_CONSUMPTION_PACKS_PENDING, true)
    commit(SET_SUBSCRIPTION_CONSUMPTION_PACKS_ERROR, null)
    try {
      const response = await service.getSubscriptionConsumptionPacks()
      commit(SET_SUBSCRIPTION_CONSUMPTION_PACKS, response?.data)
    } catch (error) {
      console.error(error)
      commit(SET_SUBSCRIPTION_CONSUMPTION_PACKS_ERROR, error)
      throw error
    } finally {
      commit(SET_SUBSCRIPTION_CONSUMPTION_PACKS_PENDING, false)
    }
  },
  async [GET_SUBSCRIPTION_DATAROOM_STORAGE] ({ commit }) {
    commit(SET_SUBSCRIPTION_DATAROOM_STORAGE_PENDING, true)
    commit(SET_SUBSCRIPTION_DATAROOM_STORAGE_ERROR, null)
    try {
      const response = await service.getSubscriptionDataroomStorage()
      commit(SET_SUBSCRIPTION_DATAROOM_STORAGE, response.data?.data?.dataroomPlan)
    } catch (error) {
      console.error(error)
      commit(SET_SUBSCRIPTION_DATAROOM_STORAGE_ERROR, error)
      throw error
    } finally {
      commit(SET_SUBSCRIPTION_DATAROOM_STORAGE_PENDING, false)
    }
  },
  async [DOWNLOAD_INVOICES] ({ commit }, data) {
    commit(SET_DOWNLOAD_INVOICES_PENDING, true)
    try {
      await service.downloadInvoices(data)
    } catch (error) {
      commit(SET_DOWNLOAD_INVOICES_ERROR, error)
      throw error
    } finally {
      commit(SET_DOWNLOAD_INVOICES_PENDING, false)
    }
  },
  async [GET_SUBSCRIPTION_INVOICES] ({ commit }) {
    commit(SET_SUBSCRIPTION_INVOICES_PENDING, true)
    try {
      const response = await service.getSubscriptionInvoices()
      commit(SET_SUBSCRIPTION_INVOICES, response.data)
    } catch (error) {
      commit(SET_SUBSCRIPTION_INVOICES_ERROR, error)
      throw error
    } finally {
      commit(SET_SUBSCRIPTION_INVOICES_PENDING, false)
    }
  },
  async [GET_SUBSCRIPTION] ({ commit }, subId) {
    commit(SET_SUBSCRIPTION_PENDING, true)
    try {
      const response = await service.getSubscription(subId)
      commit(SET_SUBSCRIPTION, response.data.subscription)
    } catch (error) {
      commit(SET_SUBSCRIPTION_ERROR, error)
      throw error
    } finally {
      commit(SET_SUBSCRIPTION_PENDING, false)
    }
  },
  async [GET_SUBSCRIPTION_BRANDING] ({ commit }, subdomain) {
    commit(SET_SUBSCRIPTION_BRANDING_PENDING, true)
    try {
      const response = await service.getSubscriptionBranding(subdomain)
      commit(SET_SUBSCRIPTION_BRANDING, response.data)
    } catch (error) {
      commit(SET_SUBSCRIPTION_BRANDING, null)
      console.error(error)
    } finally {
      commit(SET_SUBSCRIPTION_BRANDING_PENDING, false)
    }
  },
  async [INCREASE_DATAROOM_PLAN] ({ commit }, data) {
    commit(SET_INCREASE_DATAROOM_PLAN_PENDING, true)
    try {
      await service.increaseDataRoomPlan(data)
    } finally {
      commit(SET_INCREASE_DATAROOM_PLAN_PENDING, false)
    }
  },
  async [SHARE_SUBSCRIPTION_CONSUMPTION_PACK] ({ commit }, data) {
    commit(SET_SHARE_SUBSCRIPTION_CONSUMPTION_PACK_PENDING, true)
    try {
      await service.shareSubscriptionConsumptionPack(data)
    } finally {
      commit(SET_SHARE_SUBSCRIPTION_CONSUMPTION_PACK_PENDING, false)
    }
  },
  async [SHARE_SUBSCRIPTION_DATAROOM_PLAN] ({ commit }, data) {
    commit(SET_SHARE_SUBSCRIPTION_DATAROOM_PLAN_PENDING, true)
    try {
      await service.shareSubscriptionDataroomPlan(data)
    } finally {
      commit(SET_SHARE_SUBSCRIPTION_DATAROOM_PLAN_PENDING, false)
    }
  },
  async [GET_SIGNATURES_CONSUMPTION] ({ commit, state }, dateRange = {}) {
    commit(SET_SIGNATURES_CONSUMPTION_PENDING, true)
    commit(SET_SIGNATURES_CONSUMPTION_ERROR, null)
    try {
      const subId = state.subscription?.id
      if (!subId) {
        console.warn('Subscription ID not available, skipping signatures consumption load')
        return
      }
      const params = {}
      if (dateRange.startDate) params.startDate = dateRange.startDate
      if (dateRange.endDate) params.endDate = dateRange.endDate

      const response = await service.getSignaturesCountStats(subId, params)
      commit(SET_SIGNATURES_CONSUMPTION, response.data)
    } catch (error) {
      console.error(error)
      commit(SET_SIGNATURES_CONSUMPTION_ERROR, error)
      throw error
    } finally {
      commit(SET_SIGNATURES_CONSUMPTION_PENDING, false)
    }
  },
}
